module.exports = __webpack_public_path__ + "static/media/67.9bfd63f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/dessins_cafe/67.jpg
// module id = 662
// module chunks = 0